// Sidebar Moderation badge. The count lives at module level because the layout
// remounts on every page visit. It polls the shared `moderation_pending_count` prop
// (AdminSite::ModerationBadgeProp), which the server answers without re-running the
// open page's action.
import { untrack } from 'svelte'
import { POLL_INTERVAL_MS } from './moderation_live.js'
import { reloadSharedProp } from './shared_props.js'

let count = $state(null)
let watchers = 0
let timer = null
// The command center feeds the badge from its own refresh while it is visible.
let selfFed = () => false

let inflight = null

// One poll at a time: the layout mounts more than once while a page loads.
const refreshCount = () => {
  if (watchers === 0 || (selfFed() && !document.hidden)) return
  inflight ??= reloadSharedProp('moderation_pending_count')
    .then((value) => (count = value ?? null))
    .catch(() => {
      // Keep the last known count through a network blip.
    })
    .finally(() => (inflight = null))
}

export const moderationBadge = {
  get count() {
    return count
  },
  set(value) {
    count = value
  }
}

// Keeps polling in hidden tabs so the document-title count stays honest. The
// interval outlives individual layouts on purpose: restarting it per page visit
// would mean an admin who navigates more than once a minute never refreshes.
export const watchModerationBadge = (isSelfFed) => {
  watchers += 1
  selfFed = isSelfFed
  // Untracked so the calling effect doesn't re-run each time the count changes.
  if (untrack(() => count) === null) refreshCount()
  timer ??= setInterval(refreshCount, POLL_INTERVAL_MS)
  return () => (watchers -= 1)
}
